module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-claudia.c7ff4095.jpeg";